import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';

const stepsList = [
/*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Ingrese el valor de los bienes inmuebles', listHelp: ['153']}];

const tableStructure = [
    {id: 'reportante', title: 'Reportante'}, 
    {id: 'desc', title: 'Descripción'}, 
    {id: 'origen', title: 'Origen información'}, 
    {id: 'adquisicionNombre', title: 'Modo de adquisición'}, 
    {id: 'valDeclararCifra', title: 'Valor a declarar'},
];


class Form1 {
  id: number;
  idSugerida:number;
  desc: string;
  valCompra: string;
  anioCompra: string;
  valDeclaradoAnioAnterior: string;
  valCatastral: string;
  valAjustadoArt73: string;
  valAjustadoArt70: string;
  art: number;
  valDeclarar:number;
  valDeclararCifra:string;
  adquisicion:string;
  adquisicionNombre:string; 
  origen:string;
  reportante:string;
  mejoras:string;
  controlSugeridaForm: ControlSugeridaForm;
}

class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
  mostrar?: boolean;
}

@Component({
  selector: 'app-patrimonio-inmuebles-modal',
  templateUrl: './patrimonio-inmuebles-modal.component.html',
  styleUrls: ['./patrimonio-inmuebles-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class PatrimonioInmueblesModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public listValDecl: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave:boolean;
  tablaArt73:any;
  listaModoAdquisicion:any;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<PatrimonioInmueblesModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
    //console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
    //this.reloadSelArticulos();
    this.initializeAnios();
    //console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {
  
  }
  

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valCompra="0";
    this.modelForm.anioCompra="0";
    this.modelForm.valDeclaradoAnioAnterior="0";
    this.modelForm.valCatastral="0";
    this.modelForm.valAjustadoArt73="0";
    this.modelForm.valAjustadoArt70="0";
    this.modelForm.art=0;
    this.modelForm.valDeclarar=0;
    this.modelForm.valDeclararCifra="0";
    this.modelForm.adquisicion="0";
     this.modelForm.adquisicionNombre=""; 
    this.modelForm.origen="";
    this.modelForm.idSugerida=0;
    this.modelForm.reportante="";
    this.modelForm.mejoras="0";
    this.reloadSelArticulos();
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_190 == undefined){

      this.model.doc.cuerpo.cc_id_190 = [];
      this.model.doc.cuerpo.cc_id_191 = []; //reportante
      this.model.doc.cuerpo.cc_id_192 = []; //origen
      this.model.doc.cuerpo.cc_id_193 = []; //adquisicion
      this.model.doc.cuerpo.cc_id_194 = [];
      this.model.doc.cuerpo.cc_id_195 = [];
      this.model.doc.cuerpo.cc_id_196 = [];
      this.model.doc.cuerpo.cc_id_197 = [];
      this.model.doc.cuerpo.cc_id_198 = []; //mejoras
      this.model.doc.cuerpo.cc_id_199 = [];
      this.model.doc.cuerpo.cc_id_200 = [];
      this.model.doc.cuerpo.cc_id_201 = [];
      this.model.doc.cuerpo.cs_id_154 = "0";
   
    }  
  }

  protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649
    
    this.lstArticulos[0] = {valor:0,nombre:""};
    this.lstArticulos[1] = {valor:1,nombre:"Avaluó catastral o auto avaluó anterior mas mejoras"};
    this.lstArticulos[2] = {valor:2,nombre:"Valor de compra"};
    this.lstArticulos[3] = {valor:3,nombre:"Valor declarado año anterior"};
    this.lstArticulos[4] = {valor:4,nombre:"Reajustado Art. 70"};
    this.lstArticulos[5] = {valor:5,nombre:"Reajustado Art. 73"};
    
    const valCatastralMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valCatastral.toString(), this.modelForm.mejoras.toString());
    const valCompraMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valCompra.toString(), this.modelForm.mejoras.toString());
    const valDeclaradoAnioAnteriorMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valDeclaradoAnioAnterior.toString(), this.modelForm.mejoras.toString());
    const valAjustadoArt70Mejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valAjustadoArt70.toString(), this.modelForm.mejoras.toString());
    const valAjustadoArt73Mejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valAjustadoArt73.toString(), this.modelForm.mejoras.toString());
    
    this.listValDecl=[
      {valor:1,nombre:"Avaluó catastral o auto avaluó anterior mas mejoras $ "+this.dutilidades.redondearValorMoneda(valCatastralMejoras,true),mostrar:true},
      {valor:2,nombre:"Valor de compra mas mejoras $ "+this.dutilidades.redondearValorMoneda(valCompraMejoras,true),mostrar:true},
      {valor:3,nombre:"Valor declarado año anterior mas mejoras $ "+this.dutilidades.redondearValorMoneda(valDeclaradoAnioAnteriorMejoras,true),mostrar:true},
      {valor:4,nombre:"Reajustado Art. 70 mas mejoras $ "+this.dutilidades.redondearValorMoneda(valAjustadoArt70Mejoras,true),mostrar:true},
      {valor:5,nombre:"Reajustado Art. 73 mas mejoras $ "+this.dutilidades.redondearValorMoneda(valAjustadoArt73Mejoras,true),mostrar:true}
    ]
    if(this.modelForm.adquisicion=="1" ){
      /* if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCatastralMejoras,  valCompraMejoras) 
        || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCatastralMejoras,  valDeclaradoAnioAnteriorMejoras)
        || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCatastralMejoras,  valAjustadoArt70Mejoras)
        || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCatastralMejoras,  valAjustadoArt73Mejoras)){
          this.lstArticulos = [];
          this.lstArticulos[0] = {valor:0,nombre:""};
          if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCatastralMejoras, "0"))
            this.lstArticulos[1] = {valor:1,nombre:("Avaluó catastral o auto avaluó anterior mas mejoras: $"+this.dutilidades.redondearValorMoneda(valCatastralMejoras,true))};
      }else{
        this.lstArticulos = [];
        let i=0;
        this.lstArticulos[i] = {valor:0,nombre:""};
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCatastralMejoras, "0")){
          i++;
          this.lstArticulos[i] = {valor:1,nombre:("Avaluó catastral o auto avaluó anterior mas mejoras: $"+this.dutilidades.redondearValorMoneda(valCatastralMejoras,true))};
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCompraMejoras, "0")){
          i++;
          this.lstArticulos[i] = {valor:2,nombre:("Valor de compra mas mejoras: $"+this.dutilidades.redondearValorMoneda(valCompraMejoras,true))};
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valDeclaradoAnioAnteriorMejoras, "0")){
          i++;
          this.lstArticulos[i] = {valor:3,nombre:("Valor declarado año anterior mas mejoras: $"+this.dutilidades.redondearValorMoneda(valDeclaradoAnioAnteriorMejoras,true))};
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valAjustadoArt70Mejoras, "0")){
          i++;
          this.lstArticulos[i] = {valor:4,nombre:("Reajustado Art. 70 mas mejoras: $"+this.dutilidades.redondearValorMoneda(valAjustadoArt70Mejoras,true))};
        }
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valAjustadoArt73Mejoras, "0")){
          i++;
          this.lstArticulos[i] = {valor:5,nombre:("Reajustado Art. 73 mas mejoras: $"+this.dutilidades.redondearValorMoneda(valAjustadoArt73Mejoras,true))};
        }
      } */

        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valCompraMejoras,  valDeclaradoAnioAnteriorMejoras)
        && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valCompraMejoras,  valCatastralMejoras)){

          this.listValDecl.forEach(item => {
            if(item.valor == 2 || item.valor == 4 || item.valor == 5){
              item.mostrar = true;
            }else{
              item.mostrar = false;
            }
          });
        }else if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valDeclaradoAnioAnteriorMejoras,  valCompraMejoras)
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valDeclaradoAnioAnteriorMejoras,  valCatastralMejoras)){
            this.listValDecl.forEach(item => {
              if(item.valor == 3 || item.valor == 4 || item.valor == 5){
                item.mostrar = true;
              }else{
                item.mostrar = false;
              }
            });
        }else if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valCatastralMejoras,  valCompraMejoras)
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, valCatastralMejoras,  valDeclaradoAnioAnteriorMejoras)){
            this.listValDecl.forEach(item => {
              if(item.valor == 1 || item.valor == 4 || item.valor == 5){
                item.mostrar = true;
              }else{
                item.mostrar = false;
              }
            });
        }
      
    }else if(this.modelForm.adquisicion=="2"){
   /*    this.lstArticulos = [];
      this.lstArticulos[0] = {valor:0,nombre:""};
      this.lstArticulos[1] = {valor:1,nombre:"Valor de compra $"+this.modelForm.valCompra}; */
      this.listValDecl.forEach(item => {
        if(item.valor == 2){
          item.mostrar = true;
        }else{
          item.mostrar = false;
        }
      });
    }
    //if(!conservarArt)this.modelForm.art=0;
    this.reloadValCifra();
    
  }

  reloadValCifra(){
    const valCatastralMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valCatastral.toString(), this.modelForm.mejoras.toString());
    const valCompraMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valCompra.toString(), this.modelForm.mejoras.toString());
    const valDeclaradoAnioAnteriorMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valDeclaradoAnioAnterior.toString(), this.modelForm.mejoras.toString());
    const valAjustadoArt70Mejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valAjustadoArt70.toString(), this.modelForm.mejoras.toString());
    const valAjustadoArt73Mejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valAjustadoArt73.toString(), this.modelForm.mejoras.toString());
    if(this.modelForm.valDeclarar==1) this.modelForm.valDeclararCifra = this.dutilidades.redondearValorMoneda(valCatastralMejoras);
    else if(this.modelForm.valDeclarar==2) this.modelForm.valDeclararCifra = this.dutilidades.redondearValorMoneda(valCompraMejoras);
    else if(this.modelForm.valDeclarar==3) this.modelForm.valDeclararCifra = this.dutilidades.redondearValorMoneda(valDeclaradoAnioAnteriorMejoras);
    else if(this.modelForm.valDeclarar==4) this.modelForm.valDeclararCifra = this.dutilidades.redondearValorMoneda(valAjustadoArt70Mejoras);
    else if(this.modelForm.valDeclarar==5) this.modelForm.valDeclararCifra = this.dutilidades.redondearValorMoneda(valAjustadoArt73Mejoras);
    this.redondearFormData();
  }

  protected initializeAnios(){
   /*  for(let i=0; i<this.tablaArt73.length;i++){ 
    this.lstAnios[i]=Number(this.tablaArt73[i].anio);*/
      this.lstAnios = this.tablaArt73
      .filter(item => item.anioGravable === "2023")
      .map(item => item.anio)
      .sort((a, b) => b - a); // Ordena de mayor a menor
   // }
  }

  public operacionCs154(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
      //if(this.dataSourceBody[i].origen == "2")
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclararCifra, suma);
    /*   else
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valCatastral, suma); */
    }
    if(suma)
    this.model.doc.cuerpo.cs_id_154 = suma;
    else
    this.model.doc.cuerpo.cs_id_154 = '0';
  }

  
  /*
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;
      
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";

    this.reloadSelArticulos();

  }
  
  operacionCS158(){
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158,true);
  }
*/
  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_190.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_190[i].v;
      this.modelForm.reportante=this.model.doc.cuerpo.cc_id_191[i].v; 
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_192[i].v;
      if(this.listaModoAdquisicion[this.model.doc.cuerpo.cc_id_193[i].v-1])
        this.modelForm.adquisicionNombre=this.listaModoAdquisicion[this.model.doc.cuerpo.cc_id_193[i].v-1].nombre;
      this.modelForm.adquisicion=this.model.doc.cuerpo.cc_id_193[i].v;
      this.modelForm.anioCompra=this.model.doc.cuerpo.cc_id_194[i].v;
      this.modelForm.valCompra=this.model.doc.cuerpo.cc_id_195[i].v;
      this.modelForm.valDeclaradoAnioAnterior=this.model.doc.cuerpo.cc_id_196[i].v;
      this.modelForm.valCatastral=this.model.doc.cuerpo.cc_id_197[i].v;
      this.modelForm.mejoras=this.model.doc.cuerpo.cc_id_198[i].v; 
      this.modelForm.valAjustadoArt70=this.model.doc.cuerpo.cc_id_199[i].v;
      this.modelForm.valAjustadoArt73=this.model.doc.cuerpo.cc_id_200[i].v;
      this.modelForm.valDeclarar=Number(this.model.doc.cuerpo.cc_id_201[i].v);
      this.reloadValCifra();
      this.redondearFormData();
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida()
  {
    let indexModel = this.model.doc.cuerpo.cc_id_190.length;
    
    if(indexModel==0){
      const fieldsRecovery = ['VAR_7010','VAR_2256_4'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      
      const grupos=[
        ['VAR_2256_4'],
        ['VAR_7010']
      ];
      
      if(resData)
        {
          for(let i=0; i<resData.length; i++){
            for(let j=0; j<resData[i].item.value.length; j++){
              
              this.modelForm.id=indexModel;
              this.modelForm.desc=resData[i].item.descVar[j] && resData[i].item.descVar[j] != "" ? resData[i].item.descVar[j] : "Inmueble";
              this.modelForm.adquisicion= "1";
              this.modelForm.adquisicionNombre= this.listaModoAdquisicion[Number(this.modelForm.adquisicion)-1].nombre;
              this.modelForm.origen="0";
              this.modelForm.reportante=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];

                
              let itemGrupoFormPorEditar:Form1 = null;

              //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
              let idGrupo:number = -1;
              for(let k=0;k<grupos.length;k++){
                if(grupos[k].includes(resData[i].key)){
                  idGrupo=k;
                  break;
                }
              }

              //1. El nit ya existe? NO ->1:Agregar
              if(this.dataSourceBody.find((el)=>{
                return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
              })==undefined){
                itemGrupoFormPorEditar = null;
              }else{

                //2. Trae array de solo los del NIT
                let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                  if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                    return el;
                  }
                });

                //3. Recorrer array de solo los del NIT
                for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                  //En el registro existe una variable del GRUPO? 
                  //  - NO: Debe Editar el registro y deja de buscar
                  //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                  let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                  if(!dataGrupo){
                    itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                    break;
                  }
                }

              }
              
              //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
              if(itemGrupoFormPorEditar){
                this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                  if(itemModelForm.id == itemGrupoFormPorEditar.id){
                    itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                    itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                  }
                  return itemModelForm;
                });
              }else{
                this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
                this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
                this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
                this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                this.redondearFormData();
                this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
                this.dataSourceBody.push(this.modelForm);
                this.inicializeForm();
                indexModel++;
              }
            
            }
          }
        }
    }
  
    this.operacionCs154();
  }

  private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
    switch(idGrupo){//Depende de la variable array grupos
      case 0:
        itemModelForm.valCompra=String(valor);
      break;
      case 1:
        itemModelForm.valCatastral=String(valor);
      break;
      default:
      break;
    }
    return itemModelForm;
  }

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_190[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_191[this.modelForm.id].v=this.modelForm.reportante.toString();
    this.model.doc.cuerpo.cc_id_192[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_193[this.modelForm.id].v=this.modelForm.adquisicion.toString();
    this.model.doc.cuerpo.cc_id_194[this.modelForm.id].v=this.modelForm.anioCompra.toString();
    this.model.doc.cuerpo.cc_id_195[this.modelForm.id].v=this.modelForm.valCompra.toString();
    this.model.doc.cuerpo.cc_id_196[this.modelForm.id].v=this.modelForm.valDeclaradoAnioAnterior.toString();
    this.model.doc.cuerpo.cc_id_197[this.modelForm.id].v=this.modelForm.valCatastral.toString();
    this.model.doc.cuerpo.cc_id_198[this.modelForm.id].v=this.modelForm.mejoras.toString();
    this.model.doc.cuerpo.cc_id_199[this.modelForm.id].v=this.modelForm.valAjustadoArt70.toString();
    this.model.doc.cuerpo.cc_id_200[this.modelForm.id].v=this.modelForm.valAjustadoArt73.toString();
    this.model.doc.cuerpo.cc_id_201[this.modelForm.id].v=this.modelForm.valDeclarar.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_190.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_191.push({it: i, v:this.modelForm.reportante});
    this.model.doc.cuerpo.cc_id_192.push({it: i, v:this.modelForm.origen.toString()});
    this.model.doc.cuerpo.cc_id_193.push({it: i, v:this.modelForm.adquisicion.toString()});
    this.model.doc.cuerpo.cc_id_194.push({it: i, v:this.modelForm.anioCompra.toString()});
    this.model.doc.cuerpo.cc_id_195.push({it: i, v:this.modelForm.valCompra.toString()});
    this.model.doc.cuerpo.cc_id_196.push({it: i, v:this.modelForm.valDeclaradoAnioAnterior.toString()});
    this.model.doc.cuerpo.cc_id_197.push({it: i, v:this.modelForm.valCatastral.toString()});
    this.model.doc.cuerpo.cc_id_198.push({it: i, v:this.modelForm.mejoras});
    this.model.doc.cuerpo.cc_id_199.push({it: i, v:this.modelForm.valAjustadoArt70.toString()});
    this.model.doc.cuerpo.cc_id_200.push({it: i, v:this.modelForm.valAjustadoArt73.toString()});
    this.model.doc.cuerpo.cc_id_201.push({it: i, v:this.modelForm.valDeclarar.toString()});

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_190.splice(index,1);
    this.model.doc.cuerpo.cc_id_191.splice(index,1);
    this.model.doc.cuerpo.cc_id_192.splice(index,1);
    this.model.doc.cuerpo.cc_id_193.splice(index,1);
    this.model.doc.cuerpo.cc_id_194.splice(index,1);
    this.model.doc.cuerpo.cc_id_195.splice(index,1);
    this.model.doc.cuerpo.cc_id_196.splice(index,1);
    this.model.doc.cuerpo.cc_id_197.splice(index,1);
    this.model.doc.cuerpo.cc_id_198.splice(index,1);
    this.model.doc.cuerpo.cc_id_199.splice(index,1);
    this.model.doc.cuerpo.cc_id_200.splice(index,1);
    this.model.doc.cuerpo.cc_id_201.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_190.length;i++){
      this.model.doc.cuerpo.cc_id_190[i].it=i+1;
      this.model.doc.cuerpo.cc_id_191[i].it=i+1;
      this.model.doc.cuerpo.cc_id_192[i].it=i+1;
      this.model.doc.cuerpo.cc_id_193[i].it=i+1;
      this.model.doc.cuerpo.cc_id_194[i].it=i+1;
      this.model.doc.cuerpo.cc_id_195[i].it=i+1;
      this.model.doc.cuerpo.cc_id_196[i].it=i+1;
      this.model.doc.cuerpo.cc_id_197[i].it=i+1;
      this.model.doc.cuerpo.cc_id_198[i].it=i+1;
      this.model.doc.cuerpo.cc_id_199[i].it=i+1;
      this.model.doc.cuerpo.cc_id_200[i].it=i+1;
      this.model.doc.cuerpo.cc_id_201[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
        this.modelForm.valCompra==undefined || /* this.modelForm.valCompra=="0" || */ 
        this.modelForm.anioCompra==undefined || this.modelForm.anioCompra=="0" ||
        this.modelForm.valDeclaradoAnioAnterior==undefined || /* this.modelForm.valDeclaradoAnioAnterior=="0" ||  */
        this.modelForm.valCatastral==undefined || /* this.modelForm.valCatastral=="0" ||  */
        this.modelForm.valDeclarar==undefined || this.modelForm.valDeclarar==0 ||
/*         this.modelForm.aplicoArt73==undefined || this.modelForm.aplicoArt73==null ||
 */        this.modelForm.adquisicion==undefined || this.modelForm.adquisicion==null ||
        this.modelForm.origen==undefined || this.modelForm.origen==null ||
        this.modelForm.mejoras==undefined || this.modelForm.mejoras==null 
  }

  public redondearFormData(){
    this.modelForm.valCompra=this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(),true);
    this.modelForm.valDeclaradoAnioAnterior=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(),true);
    this.modelForm.valCatastral=this.dutilidades.redondearValorMoneda(this.modelForm.valCatastral.toString(),true);
    this.modelForm.mejoras=this.dutilidades.redondearValorMoneda(this.modelForm.mejoras.toString(),true);
     this.modelForm.valDeclararCifra=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclararCifra.toString(),true); 

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();

    if(this.modelForm.adquisicion=="1" && this.modelForm.anioCompra!="0"){
      this.modelForm.valAjustadoArt70 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valDeclaradoAnioAnterior.toString(), "1.1240",true);
      this.modelForm.valAjustadoArt70 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt70.toString(),true);
      /* if(this.modelForm.aplicoArt73=="1"){ */
        let registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.anioCompra == ite.anio && ite.anioGravable == "2023");
        let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valCompra.toString(), registroArt73.bienes.toString(),false);
        this.modelForm.valAjustadoArt73 = resultado;
        this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
    
      /* }else{
        this.modelForm.valAjustadoArt73 = "0";
      } */
      this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
    }else{
      this.modelForm.valAjustadoArt70 = "0";
      this.modelForm.valAjustadoArt73 = "0";
    }
    this.reloadSelArticulos();
    
/*     switch(Number(this.modelForm.art)){
      case 1:
        if(this.modelForm.adquisicion=="1")
          this.modelForm.valDeclarar =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valCatastral.toString(), this.modelForm.mejoras.toString());
        else
          this.modelForm.valDeclarar = this.modelForm.valCompra.toString();

        break;
      case 2:
        if(this.modelForm.adquisicion=="1"){
          this.modelForm.valDeclarar = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valCompra.toString(), this.modelForm.mejoras.toString());
        }else{
          this.modelForm.valDeclarar = this.modelForm.valCompra.toString();

        }
        break;
      case 3:
        this.modelForm.valDeclarar =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valDeclaradoAnioAnterior.toString(), this.modelForm.mejoras.toString());
        break;
      case 4:
        this.modelForm.valDeclarar =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valAjustadoArt70.toString(), this.modelForm.mejoras.toString());
        break;
      case 5:
        this.modelForm.valDeclarar =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.modelForm.valAjustadoArt73.toString(), this.modelForm.mejoras.toString());
        break;  
      default:
        this.modelForm.valDeclarar = "0";      
    }
    this.modelForm.valDeclarar = this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);
    this.reloadSelArticulos(conservarArt); */
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        /*
        const existeValor = this.model.doc.cuerpo.cc_id_190.some(item => item.v === this.modelForm.desc);
      
        if(this.modelForm.origen=="2" || this.modelForm.origen=="1" || (existeValor && this.modelForm.origen=="0")){ //editando contribuyente o editando sugerida
          this.modelForm.origen = this.modelForm.origen=="0" && this.modelForm.origen=="0" ? "1" : this.modelForm.origen;
          this.editModeloDesdeForm();
        }else if(this.modelForm.origen=="0"){ //editando sugerida
          this.modelForm.origen = "1";
          this.modelForm.id = this.model.doc.cuerpo.cc_id_190.length;
          this.addToModeloDesdeForm();
        }
        */
        this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion)-1].nombre;
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
       // this.editModeloDesdeForm(); 
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_190.length;
        this.modelForm.origen = "2";
        this.modelForm.reportante = "Contribuyente";
        this.modelForm.adquisicionNombre = this.listaModoAdquisicion[Number(this.modelForm.adquisicion)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs154();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs154();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO
/*   public validateRbQuestions(val: string) {
    this.modelForm.aplicoArt73 = val;
    this.calcularValoresForm();
  } */
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
 /*  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  } */

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  /* public validateBtnRightActive(){

  } */

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs154();
    /* this.changeStepLocal(0); */
    this.dialogRef.close("");
  }
  public guardar(){
    /*if(!this.validarTablaCompleta()){
      return;
    }*/
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_190 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs154();
    
    this.saveModel.emit(true); 
    //if(this.indexStepper==this.stepsList.length-1){
    this.closeModal();
    //} 
  }
  private validarTablaCompleta(){
    let res=true;
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      if(this.validateFormCompleted()){
        res=false;
        let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos en cada registro para guardar");
        break;
      }
    }
    return res;
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-inmuebles-modal/patrimonio-inmuebles-modal.component.ts